/* Copyright Information: Created by BuyGroup */
import Api from "../Api";

export const editProfile = (data) => {
  return Api.put("user", data).then((res) => res.data);
};
/* Copyright Information: Created by BuyGroup */
